import Reveal from "./Reveal";
import { professional } from "@/config/professional";

export default function LaserTherapy() {
  return (
    <section id="laserterapia" className="bg-background-100 py-16 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          {/* Copy */}
          <div>
            <Reveal>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
                Laserterapia
              </p>
              <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
                Tecnologia como aliada do cuidado.
              </h2>
            </Reveal>

            <Reveal delay={80}>
              <div className="mt-7 space-y-5 text-base leading-relaxed text-foreground-600 md:text-[1.05rem]">
                <p>
                  A Laserterapia é um recurso terapêutico que utiliza luz em
                  comprimentos de onda específicos. Ela pode auxiliar em
                  protocolos de cicatrização e no alívio da dor, quando
                  indicada após avaliação profissional.
                </p>
                <p>
                  Cada protocolo é individualizado: a indicação depende da
                  avaliação da profissional, do histórico e da necessidade de
                  cada pessoa. A Laserterapia não substitui o acompanhamento
                  médico.
                </p>
              </div>
            </Reveal>

            <Reveal delay={140}>
              <ul className="mt-8 space-y-3">
                {[
                  "Recurso terapêutico complementar",
                  "Protocolo individualizado",
                  "Indicação após avaliação profissional",
                  "Foco em cicatrização e alívio da dor",
                ].map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-3 text-base text-foreground-700"
                  >
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-check-line text-sm" aria-hidden="true"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={200}>
              <a
                href={professional.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group mt-9 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-600 px-7 py-4 text-base font-semibold text-background-50 transition-colors hover:bg-primary-700"
              >
                Quero saber se é indicado para mim
                <i
                  className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"
                  aria-hidden="true"
                ></i>
              </a>
            </Reveal>
          </div>

          {/* Image */}
          <Reveal delay={100}>
            <div className="relative">
              <div className="absolute -right-4 -top-4 h-full w-full rounded-lg border border-primary-600/15" />
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src={professional.laserImage}
                  alt="Equipamento de laserterapia em atendimento profissional"
                  className="h-[380px] w-full object-cover object-top md:h-[480px]"
                />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}